import { render } from "./richTextElement.vue?vue&type=template&id=ec5ce8f8"
import script from "./richTextElement.vue?vue&type=script&lang=js"
export * from "./richTextElement.vue?vue&type=script&lang=js"

import "./richTextElement.vue?vue&type=style&index=0&id=ec5ce8f8&lang=scss"

import exportComponent from "C:\\Users\\jekr\\Documents\\studievalg-digital-tool\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__